import BaseService from '_services/rest/base';

class SettingsService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/settings`;
  }

  getSettings() {
    return this.request(`${this.getUrl()}/all`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  prepareOptions(settings, type = 'company') {
    const options = [];
    Object.keys(settings).map(key => (
      options.push({
        option: `${type}_${key}`,
        value: settings[key] || '',
      })
    ));
    return { ...options };
  }

  saveOptions(settings, type) {
    const options = this.prepareOptions(settings, type);
    return this.request(`${this.getUrl()}`, { options }, 'PUT')
      .catch(err => {
        throw err;
      });
  }
}

export default new SettingsService();
